import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ApolloProvider } from '@apollo/client'
import { apolloClient } from './utils/apollo/apolloClient'
import { StyledEngineProvider } from '@mui/styled-engine-sc'
import { CssBaseline } from '@mui/material'
import LocalizedThemeProvider from './components/Shared/LocalizedThemeProvider'
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import './i18n'
import 'react-toastify/dist/ReactToastify.css'
import { Toast } from './components/Shared/ToastContainer'
import AppConfigWrapper from './components/Maintenance/AppConfigWrapper'
import 'dayjs/locale/pl'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <LocalizedThemeProvider>
            <CssBaseline />
            <AppConfigWrapper>
              <HashRouter>
                <App />
                <Toast />
              </HashRouter>
            </AppConfigWrapper>
          </LocalizedThemeProvider>
        </StyledEngineProvider>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
